(() => {
  const money = (cents, format) => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-CH', {
        style: 'currency',
        currency: format || 'CHF'
      }).format(value);
    } catch (_) {
      return `${value.toFixed(2)} ${format || 'CHF'}`;
    }
  };

  function closeHeaderSearch(except = null) {
    document.querySelectorAll('[data-header-search].is-open').forEach((search) => {
      if (search === except) return;
      search.classList.remove('is-open');
      search.querySelector('[data-header-search-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('change', (event) => {
    const localeSelect = event.target.closest('[data-locale-select]');
    if (localeSelect) localeSelect.form?.submit();
  });

  document.addEventListener('click', (event) => {
    const backLink = event.target.closest('[data-product-back]');
    if (backLink) {
      try {
        const referrer = document.referrer ? new URL(document.referrer) : null;
        if (referrer && referrer.origin === window.location.origin && window.history.length > 1) {
          event.preventDefault();
          window.history.back();
          return;
        }
      } catch (_) {
        // Fallback-Link bleibt aktiv.
      }
    }
    const toggle = event.target.closest('[data-header-search-toggle]');
    if (toggle) {
      const search = toggle.closest('[data-header-search]');
      if (!search) return;
      const shouldOpen = !search.classList.contains('is-open');
      closeHeaderSearch(search);
      search.classList.toggle('is-open', shouldOpen);
      toggle.setAttribute('aria-expanded', String(shouldOpen));
      if (shouldOpen) window.setTimeout(() => search.querySelector('input[type="search"]')?.focus(), 0);
      return;
    }

    if (!event.target.closest('[data-header-search]')) closeHeaderSearch();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeHeaderSearch();
    document.querySelectorAll('details[open]').forEach((details) => {
      details.removeAttribute('open');
    });
  });

  function initProductForm(form) {
    if (form.dataset.initialized === 'true') return;
    form.dataset.initialized = 'true';

    const variantSelect = form.querySelector('[data-variant-select]');
    const variantJson = form.querySelector('[data-variant-json]');
    const price = document.querySelector(`[data-product-price="${form.dataset.sectionId}"]`);
    const compare = document.querySelector(`[data-product-compare="${form.dataset.sectionId}"]`);
    const button = form.querySelector('[name="add"]');
    const buttonText = button?.querySelector('[data-add-text]');

    if (!variantSelect || !variantJson) return;

    let variants = [];
    try { variants = JSON.parse(variantJson.textContent); } catch (_) { return; }

    variantSelect.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === variantSelect.value);
      if (!variant) return;

      if (price) price.textContent = money(variant.price, form.dataset.currency);
      if (compare) {
        compare.textContent = variant.compare_at_price > variant.price
          ? money(variant.compare_at_price, form.dataset.currency)
          : '';
        compare.hidden = !(variant.compare_at_price > variant.price);
      }

      if (button) {
        button.disabled = !variant.available;
        if (buttonText) buttonText.textContent = variant.available
          ? form.dataset.addLabel
          : form.dataset.soldOutLabel;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-product-form]').forEach(initProductForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
